import { render, staticRenderFns } from "./LearningPrograms.vue?vue&type=template&id=3f640c41&"
import script from "./LearningPrograms.vue?vue&type=script&lang=js&"
export * from "./LearningPrograms.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports